import { render, staticRenderFns } from "./GridDataSource.vue?vue&type=template&id=a0d6680a&scoped=true&"
import script from "./GridDataSource.vue?vue&type=script&lang=js&"
export * from "./GridDataSource.vue?vue&type=script&lang=js&"
import style0 from "./GridDataSource.vue?vue&type=style&index=0&id=a0d6680a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d6680a",
  null
  
)

export default component.exports